<template>
    <table class="table table-striped additions-table">
        <thead>
            <tr>
                <th colspan="4">{{ trans["type-" + item.type] }}</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th>
                    {{ this.getLabel() }}:

                    <div class="float-right">
                        <button
                            class="btn btn-link p-0"
                            @click="unsetCustomValue()"
                            v-b-tooltip.hover
                            :title="trans.resetBtn"
                            v-if="isModified()"
                        >
                            <i
                                class="fas fa-spinner text-danger"
                                v-if="this.loadingUnset"
                            ></i>
                            <i class="fal fa-fw fa-sync text-danger" v-else></i>
                        </button>
                    </div>
                </th>
                <td class="text-right" style="width: 40%;" colspan="2">
                    <div class="input-group">
                        <input
                            type="number"
                            step="0.01"
                            class="form-control"
                            v-model="mutableCurrentValue"
                            :disabled="loading"
                            :class="{ 'loading disabled': loading }"
                            autocomplete="off"
                            @blur="fixEmptyAmount($event.target.value)"
                        />
                        <div class="input-group-append">
                            <span class="input-group-text">
                                {{ restaurantCurrency }}
                            </span>
                        </div>
                    </div>
                </td>
                <td style="width: 10%;">
                    <button
                        type="button"
                        class="btn btn-success btn-square-loading-save"
                        :class="{ 'loading disabled': loading }"
                        @click="saveCustomValue"
                    >
                        <i class="fal fa-save"></i
                        ><i class="loadingSpinner"></i>
                    </button>
                </td>
            </tr>

            <tr>
                <td style="width: 50%">
                    <b>{{ trans.together }}:</b>
                </td>
                <td class="pl-3">
                    <span v-if="isHourlyWage()"
                        >&times;
                        <b>{{ formatHours(workedHoursTotal) }}</b></span
                    >
                </td>
                <td class="text-right">
                    <b><span v-html="getTotalAmount()"></span></b>
                </td>
                <td class="text-center" style="white-space: nowrap;"></td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import { formatHours, formatMoney } from "../../utils";
export default {
    name: "dynamic-addition",
    data: function() {
        return {
            loading: false,
            loadingUnset: false,
            mutableCurrentValue: this.item.value
                ? this.item.value
                : this.item.default_value
        };
    },

    props: {
        item: {
            type: Object
        },
        trans: {
            type: Object
        },
        restaurantCurrency: {
            type: String
        },
        contractSettings: {
            type: Object
        },
        urlSave: {
            type: String
        },
        urlUnset: {
            type: String
        },
        workedHoursTotal: {
            type: Number
        }
    },

    methods: {
        formatHours(x) {
            return formatHours(x);
        },
        formatMoney(x) {
            return formatMoney(x, this.restaurantCurrency);
        },
        isHourlyWage() {
            return this.item.calculation == "hourly";
        },

        getLabel() {
            return this.trans[this.item.calculation + "-rate"];
        },

        refreshModelData() {
            this.$emit("refreshdata");
        },

        unsetCustomValue() {
            this.loadingUnset = true;

            axios
                .post(this.urlUnset, null)
                .then(response => {
                    let defaultValue = parseFloat(response.data.defaultValue);
                    this.mutableCurrentValue =
                        defaultValue && defaultValue != "NaN"
                            ? defaultValue.toFixed(2)
                            : "0.00";

                    this.loadingUnset = false;
                    this.refreshModelData();
                    this.$notify({
                        type: "success",
                        title: this.trans.form.success,
                        text: this.trans.form.success_message
                    });
                })
                .catch(error => {
                    this.loadingUnset = false;
                    this.refreshModelData();
                    this.$notify({
                        type: "error",
                        title: this.trans.form.error,
                        text:
                            error.response.data.errors &&
                            error.response.data.errors.amount &&
                            error.response.data.errors.amount.length > 0
                                ? error.response.data.errors.amount[0]
                                : "An error has occured."
                    });
                });
        },

        saveCustomValue() {
            this.loading = true;

            const data = {
                amount: this.mutableCurrentValue
            };

            axios
                .post(this.urlSave, data)
                .then(response => {
                    this.loading = false;
                    this.refreshModelData();
                    this.$notify({
                        type: "success",
                        title: this.trans.form.success,
                        text: this.trans.form.success_message
                    });
                })
                .catch(error => {
                    this.loading = false;
                    this.refreshModelData();
                    this.$notify({
                        type: "error",
                        title: this.trans.form.error,
                        text:
                            error.response.data.errors &&
                            error.response.data.errors.amount &&
                            error.response.data.errors.amount.length > 0
                                ? error.response.data.errors.amount[0]
                                : "An error has occured."
                    });
                });
        },

        isModified() {
            return (
                parseFloat(this.item.default_value).toFixed(4) !=
                parseFloat(this.mutableCurrentValue).toFixed(4)
            );
        },

        fixEmptyAmount(val) {
            if (val === "" || val == null) {
                this.mutableCurrentValue = 0;
            }
        },

        getTotalAmount() {
            if (this.isHourlyWage()) {
                return formatMoney(
                    this.workedHoursTotal *
                        parseFloat(
                            this.mutableCurrentValue
                                ? this.mutableCurrentValue
                                : 0
                        ),
                    this.restaurantCurrency
                );
            } else {
                return formatMoney(
                    this.mutableCurrentValue,
                    this.restaurantCurrency
                );
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.btn-square-loading-save,
.btn.loading.btn-square-loading-save {
    width: 38px;
    height: 35px;
    padding-right: 0.75rem !important;
    text-align: center;

    .loadingSpinner {
        margin-left: -10px;
        left: auto;
        right: auto;
    }
}
.form-control {
    padding-right: 12px !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/show/DynamicAddition.vue